import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { RowActionsMenu } from './RowActionsMenu'

type WorkspaceSetting = RestSchemas['Messages.Workspaces.WorkspaceSetting']

export const workspaceSettingsColumns: ColumnDef<WorkspaceSetting>[] = [
  {
    id: 'key',
    accessorKey: 'key',
    header: ({ column }) => <SortingHeaderButton column={column}>Setting key</SortingHeaderButton>,
    cell: ({ row }) => row.original.key ?? 'Not set',
    sortingFn: (rowA, rowB) => (rowA.original.key ?? '').localeCompare(rowB.original.key ?? ''),
  },
  {
    id: 'value',
    accessorKey: 'value',
    header: ({ column }) => <SortingHeaderButton column={column}>Setting value</SortingHeaderButton>,
    cell: ({ row }) => row.original.value ?? 'Not set',
    sortingFn: (rowA, rowB) => (rowA.original.value ?? '').localeCompare(rowB.original.value ?? ''),
  },
  {
    id: 'actions',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <RowActionsMenu row={row.original} />
      </div>
    ),
  },
]
